import request from '@/http/http'
import qs from 'qs'
export function loginByUsername(username, password,tenantId) {
    const data = qs.stringify({
        client_id: "Deer_Admin",
        client_secret: "1q2w3e*",
        grant_type: "password",
        username,
        password
    })
    let url=tenantId?'connect/token?__tenant='+tenantId:'connect/token';
    return request({
        url,
        method: 'post',
        data
    })
}

export function refreshToken(token) {
    const data = qs.stringify({
        client_id: 'Deer_Admin',
        client_secret: '1q2w3e*',
        grant_type: 'refresh_token',
        refresh_token: token
    })

    return request({
        url: 'connect/token',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: '/login/logout',
        method: 'post'
    })
}
